import { render } from "./SvgLocation.vue?vue&type=template&id=492fb847&ts=true"
import script from "./SvgLocation.vue?vue&type=script&lang=ts"
export * from "./SvgLocation.vue?vue&type=script&lang=ts"

import "./SvgLocation.vue?vue&type=style&index=0&id=492fb847&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__